const inFlight = new Map();

export const fetchGitHubRepos = async (date, page = 1, perPage = 30) => {
 // Create a unique cache key for this request (based on date + pagination)
  const key = `${date}|${page}|${perPage}`;

  // If the same request is already being made, return the existing Promise
  if (inFlight.has(key)) {
    return inFlight.get(key);
  }

  const url = `https://api.github.com/search/repositories?q=created:>${date}&sort=stars&order=desc&page=${page}&per_page=${perPage}`;

  const promise = fetch(url)
    .then(async (response) => {
      if (!response.ok) {
        const text = await response.text();
        throw new Error(`Error: ${response.status} ${response.statusText} ${text}`);
      }
      const json = await response.json();
      return json;
    })
    .finally(() => {
      // remove from map when finished (success or failure)
      inFlight.delete(key);
    });

  inFlight.set(key, promise);
  return promise;
};
